import { render, staticRenderFns } from "./CostTruck.vue?vue&type=template&id=1a6d11be&"
import script from "./CostTruck.vue?vue&type=script&lang=js&"
export * from "./CostTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports